<template>
  <v-card class="dashboard-item limit-dimensions">
    <v-img
      v-if="image"
      :src="image"
      aspect-ratio="2.57"
      class="flex-none"
    >
      <div v-if="whiteOverlay" class="image-overlay-white"></div>
      <div class="image-overlay"></div>
      <slot name="image-overlay"></slot>
    </v-img>
    <v-card-text class="d-flex align-start justify-center flex-column">
      <div class="text-color__dark H2 one-line reservation-title">{{ title }}</div>
      <v-layout justify-start align-center class="text-color__dark app-body-2 medium-icons" :class="{'colored-icons': invertIconColor }">
        <v-icon small :color="invertIconColor ? 'primary lighten-1' : 'primary darken-1'" class="material-symbols-rounded mr-1">calendar_month</v-icon>
        <div class="mr-3">{{ date }}</div>
        <v-icon small :color="invertIconColor ? 'primary lighten-1' : 'primary darken-1'" class="material-symbols-rounded mr-1">chronic</v-icon>
        <div>{{ time }}</div>
        <template v-if="room">
          <v-icon small :color="invertIconColor ? 'primary lighten-1' : 'primary darken-1'" class="material-symbols-rounded mr-1 ml-3">bed</v-icon>
          <div>{{ room }}</div>
        </template>
        <template v-if="(!room || !displayRoomOrAttendees) && attendees">
          <v-icon small :color="invertIconColor ? 'primary lighten-1' : 'primary darken-1'" class="material-symbols-rounded mr-1 ml-3">group</v-icon>
          <div class="attendees_badge">{{ attendees }}</div>
        </template>
      </v-layout>
      <v-container class="pa-0 flex-button-container" v-if="!!$slots.buttons">
        <v-layout row class="ma-0">
          <slot name="buttons"></slot>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-text v-if="!!$slots.append" class="append-section">
        <slot name="append"></slot>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  // SLOTS: buttons, append
  props: {
    image: String,
    whiteOverlay: Boolean,
    title: String,
    date: String,
    time: String,
    room: String,
    attendees: Number,
    displayRoomOrAttendees: {
      type: Boolean,
      default: false,
    },
    invertIconColor: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>

.medium-icons .v-icon {
  font-size: 18px !important;
}
.reservation-title {
  margin-bottom: 7px;
}
.append-section {
  background-color: rgba(var(--v-primary-lighten1-rgb), 0.1);
}
.dashboard-item {
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--v-custom-grey-lighten1);
  box-shadow: 0px 0px 28px 0px rgba(0, 0, 0, 0.10) !important;
  height: 100%;
  .one-line {
    max-width: calc(100%);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .description {
    margin-top: 5px;
  }
  .v-image {
    position: relative;
  }
  .image-overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    border-radius: 10px 10px 0px 0px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.60) 8.09%, rgba(0, 0, 0, 0.00) 38.73%, rgba(0, 0, 0, 0.00) 59.79%, rgba(0, 0, 0, 0.60) 100%);
  }
  .image-overlay-white {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    border-radius: 10px 10px 0px 0px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.73) 12.55%, rgba(255, 255, 255, 0.81) 100%, rgba(255, 255, 255, 0.37) 100%);
    backdrop-filter: blur(0.75px);
  }
  .v-card__text {
    padding: 20px;
    vertical-align: middle;
  }
  .container {
    margin-top: 14px;
  }
}
.dashboard-item.limit-dimensions {
  // max-height: 278px;
  .image-overlay, .v-image {
    height: 138px;
  }
  .v-card__text {
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 16px;
  }
}
</style>
